
















































import { Vue, Component } from 'vue-property-decorator';
import { List, Sticky, Progress } from 'vant';
import { getRank } from '../api';

Vue.use(List).use(Progress).use(Sticky);
@Component
export default class Rank extends Vue {
  tabs = [
    { text: '智能手机', id: 1 },
    { text: '电商消费', id: 2 },
    { text: '网络出行', id: 4 },
    { text: '百货卖场', id: 3 },
    { text: '家居卖场', id: 5 },
    { text: '家装公司', id: 6 },
    { text: '建材品牌', id: 7 },
  ];
  activeIndex = 0;

  dataList: any = [];
  get id() {
    return this.tabs[this.activeIndex].id;
  }
  get maxVote() {
    const map = this.dataList.map((item: any) => item.votes);
    return Math.max(...map);
  }
  get maxDisVote() {
    const map = this.dataList.map((item: any) => item.dis_votes);
    return Math.max(...map);
  }
  created() {
    this.fetchData();
  }
  fetchData() {
    getRank(this.id).then((res) => {
      this.dataList = res.data;
    });
  }
  changeIndex(index: number) {
    this.activeIndex = index;
    this.dataList = [];
    this.fetchData();
  }
  calcPercentage(value: number, type: 1 | 2) {
    const data =
      type === 1
        ? (value / this.maxVote) * 100
        : (value / this.maxDisVote) * 100;
    return data ? data : 0;
  }
}
